<template>
  <div>
    <h3 class="pt-0 mt-0 pb-0">{{ $t('viewSettings.repairtimetree.title') }}</h3>
    <v-row class="mx-0 w-100">
      <v-col class="mt-2 pt-0 pb-0 mb-0 px-0 mx-0">
      <repairtime-tree :editable="true"/>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {mapFields} from 'vuex-map-fields';
import router from "../../router";
import RepairtimeTree from "@/components/repairtime/RepairtimeTree";

export default {
  name: "RepairTimeTypes",
  components: {RepairtimeTree},
  data: () => ({}),
  created() {
    this.onLoad();
  },
  computed: {
    ...mapFields('repairtimes', ['repairtimetypes']),

  },
  watch: {
    '$route'(to, from) {
      this.onLoad();
    }
  },
  methods: {
    onLoad() {
      this.$store.dispatch('repairtimes/typesGet')
    },
  }
}
</script>

<style scoped>

</style>